export class TablePermission{
    public name: string;
    public actualName?: string;
    public id?: string;
    public permission: string="None";
}